import userRepository from './user/userRepository'

export default {
    userRepository: userRepository,
}
